app.headerController = app.headerController || {};
app.headerController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        this.showMobileNav();
    },

    showMobileNav : function () {
        $('.hamburger').on('click', function() {
            $(this).toggleClass('is-active');
            $('.menu-mobile').toggleClass('menu-active');
        });
    },

};

$(document).ready(function(){
    app.headerController.defaultAction.init();
});